function getItem(key) {
  const val = localStorage.getItem(key);

  // ✅ Handle null, undefined, "undefined", "null", and empty string
  if (!val || val === 'undefined' || val === 'null') {
    return null;
  }

  try {
    return JSON.parse(val);
  } catch (error) {
    console.warn(`Failed to parse localStorage item "${key}":`, error);
    return null;
  }
}

function setItem(key, value) {
  return localStorage.setItem(key, JSON.stringify(value));
}

function updateItem(key, fieldKey, value) {
  const data = getItem(key);

  // ✅ If data doesn't exist or isn't an object, create new object
  if (!data || typeof data !== 'object') {
    return localStorage.setItem(key, JSON.stringify({ [fieldKey]: value }));
  }

  data[fieldKey] = value;
  return localStorage.setItem(key, JSON.stringify(data));
}

function removeItem(key) {
  return localStorage.removeItem(key);
}

const LocalstorageService = {
  getItem,
  setItem,
  updateItem,
  removeItem,
};

export default LocalstorageService;




